module.exports = __webpack_public_path__ + "img/memory_27.42b4caf9.jpg";